import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { address } from './modules/address';
import { invoice } from './modules/invoice';
import { home } from './modules/home';
import { card } from './modules/card';
import { user } from './modules/user';
import { order } from './modules/order';
import { search } from './modules/search';
import { equipment } from './modules/equipment';
import { notifys } from './modules/notifys';
import { white } from './modules/whiteS';

Vue.use(Vuex);
const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0'
  },
  modules: {
    address,
    invoice,
    home,
    card,
    user,
    order,
    search,
    notifys,
    equipment,
    white
  }
};
export default new Vuex.Store<RootState>(store);
